export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '参数编号', dataIndex: 'argCode', width: 200},
    {title: '参数名称', dataIndex: 'argName', width: 160, ellipsis: true},
    {title: '参数类型', dataIndex: 'argTypeStr', width: 160},
    {title: '参数可选项', dataIndex: 'argValueJson', render:'jsonRender', ellipsis: true},
  ],
}
